import { z } from "zod";



import { FormField } from "../../../FormEngine/types";





/**
 * Weight Loss Progress form schema
 *
 * This schema defines the fields for the Weight Loss Progress form
 * using the FormEngine component.
 */
export const weightLossProgressSchema: FormField[] = [
  {
    type: "textarea",
    name: "weightLossProgress",
    title: "Weight Loss Progress",
    description: "How do you feel about your weight loss progress?",
    fieldProps: {
      sx: { mt: 0 },
    },
  },
  {
    type: "group-input",
    name: "changesInSleep",
    title: "Changes in Sleep",
    description: "Have you observed any changes in sleep, PAP use, or tolerance?",
    group: [
      {
        type: "radio",
        name: "changesInSleep.response",
        fieldProps: {
          options: [
            { label: "Yes", value: true },
            { label: "No", value: false },
          ],
          sx: { flexDirection: "row", gap: 1 },
        },
      },
      {
        type: "input",
        name: "changesInSleep.description",
        label: "Description",
        conditional: {
          label: "changesInSleep.response",
          values: [true],
        },
      },
    ],
    fieldProps: {
      direction: "column",
    },
  },
  {
    type: "textarea",
    name: "additionalComments",
    title: "Additional Comments",
    description: "Is there anything else you'd like to discuss with your specialist?",
    fieldProps: {
      sx: { mt: 0 },
    },
  },
];

export default weightLossProgressSchema;